import { AnyAction } from 'redux';
import { StreamingReducer } from '../../models/Redux';
import {
    FILTER_USER_MESSAGES_STREAMING_CHAT_MESSAGE,
    PUSH_STREAMING_CHAT_MESSAGE,
    SET_CURRENT_EVENT,
    SET_EVENT_UUID,
    SET_LOADING_STREAMING,
    SET_LOCAL_STREAMING_STATE,
    SET_STREAMING_FLAGS,
    SET_STREAMING_STATE,
} from '../actions/Streaming.actions';
import { EVENT_UUID } from '../../environment/environment';

const MAX_CHAT_SIZE = 100;

const initialState: StreamingReducer = {
    eventUuid: EVENT_UUID,
    eventData: {
        event: {},
        influencer: {},
        user: {},
        attendees_users: [],
        reviews: [],
    },
    streamingState: {
        current_state: {
            messages: [],
        },
    },
    streamingChat: [],
    localStreamingState: {
        microphone: true,
        camera: true,
        sharingScreen: false,
        raiseHand: false,
        room: null,
        mainParticipant: null,
        participants: [],
        videoFitMode: 'contain',
        settingsModal: true,
        showParticipantList: false,
        showChat: true,
    },
    streamingFlags: {
        started: false,
        connected: false,
        webSocketConnected: false,
        hasTurn: false,
    },
    loading: true,
    error: false,
};

const streamingReducer = (state = initialState, action: AnyAction): StreamingReducer => {
    switch (action.type) {
        case SET_LOADING_STREAMING:
            return { ...state, loading: action.payload };
        case SET_STREAMING_STATE:
            return { ...state, streamingState: action.payload, loading: false };
        case SET_CURRENT_EVENT:
            return { ...state, eventData: action.payload, loading: false };
        case SET_LOCAL_STREAMING_STATE:
            return { ...state, localStreamingState: action.payload };
        case SET_STREAMING_FLAGS:
            return { ...state, streamingFlags: action.payload };
        case SET_EVENT_UUID:
            return { ...state, eventUuid: action.payload };
        case PUSH_STREAMING_CHAT_MESSAGE:
            return {
                ...state,
                streamingChat: [...state.streamingChat.slice(-MAX_CHAT_SIZE), action.payload],
            };
        case FILTER_USER_MESSAGES_STREAMING_CHAT_MESSAGE:
            return {
                ...state,
                streamingChat: [
                    ...state.streamingChat.filter(message => message.user.user_username !== action.payload),
                ],
            };
        default:
            return state;
    }
};
export default streamingReducer;
